/**
 * Init hero slider.
 */

const sliderHero = function() {
  const $slider = $('.js-slider-hero');

  if( ! $slider.length ) {
    return;
  }

  $slider.slick({
    arrows: false,
    autoplay: true,
    fade: true,
    cssEase: 'ease',
    autoplaySpeed: 5000,
    pauseOnHover: false
  })
}

sliderHero()
